import * as React from 'react';
import { FieldProps } from '../metadataFormField';
import { getFieldValue } from '../../../utils';
import { FieldGroup } from '../FieldGroup/fieldGroup';
import { EnumInput } from '../../EnumInput/enumInput';
import { SearchInput } from '../../SearchInput/searchInput';

export const EnumField = (props: FieldProps) => {
  const { field, data, disabled, updater } = props;
  const { updateField, update } = updater;
  const multiple = field?.multiValue;
  const value = getFieldValue(field, data);
  const enumValues = field?.enumValues || {};

  const displayValues = React.useMemo(
    () =>
      (Array.isArray(value) ? value : [value])
        .map(v => enumValues[v] || v)
        .filter(Boolean)
        .join(', '),
    [value, enumValues]
  );

  const handleSetValues = React.useCallback(
    (newValues: string[]) => {
      const newValue = multiple ? newValues : newValues[0];
      updateField(field, newValue);
    },
    [field]
  );
  return (
    <FieldGroup {...props} disabled={disabled} value={displayValues}>
      <div className={'input-group input-group hide'}>
        <EnumInput
          enumValues={field?.enumValues}
          selected={value}
          onChange={handleSetValues}
          onBlur={update}
          multiple={multiple}
        />
        {<SearchInput />}
      </div>
    </FieldGroup>
  );
};
